import { memo, useEffect, useState } from 'react';
import { Box3Helper } from 'three';

import { useDragAndDrop } from '../../hooks/index.js';

export const DragAndDrop: React.FC = memo(() => {
  const { box } = useDragAndDrop();

  const [boxHelper, setBoxHelper] = useState<Box3Helper | null>(null);

  useEffect(() => {
    setBoxHelper((prev) => {
      prev?.dispose();
      return box ? new Box3Helper(box, 'blue') : null;
    });
  }, [box]);

  return <>{boxHelper && <primitive object={boxHelper} />}</>;
});
